const compareSlidersDefaults = {
    slidesPerView: 2,
    allowTouchMove: true,
    spaceBetween: 8,
    resistanceRatio: 0.7,
    watchOverflow: true,

    breakpoints: {
        768: {
            resistanceRatio: 0,
            slidesPerView: 6,
            allowTouchMove: false,
            spaceBetween: 14,
        },
    },
};

export { compareSlidersDefaults };
